import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled, { css } from 'styled-components'

export default function CampaignNavBar({
  match,
  setCenterModalVisible,
  setCenterModalDataList,
  setOnModalComplete,
  setInitCenterModal,
  userInfo,
  groupInfo,
}) {
  const [currTab, setCurrTab] = useState('info')

  const history = useHistory()

  const onReplace = (type) => {
    if (type === 'community') {
      if (!userInfo?.isLogin) {
        setCenterModalVisible(true)
        setCenterModalDataList({ type: 'callback', description: '로그인이 필요해요' })
        setOnModalComplete(() => () => history.push(`/social?redirect_path=${match.url}`))
        return
      }
      if (!groupInfo?.is_member) {
        setCenterModalVisible(true)
        setCenterModalDataList({
          type: 'callback',
          description: '챌린지에 가입하시면 볼 수 있어요',
        })
        setOnModalComplete(() => () => setInitCenterModal(true))
        return
      }
      history.replace(`${match.url}/community`)
    } else if (type === 'feed') {
      history.replace(`${match.url}/feed`)
    } else if (type === 'achievement_rate') {
      history.replace(`${match.url}/achievement`)
    } else {
      history.replace(`${match.url}/info`)
    }
  }

  useEffect(() => {
    const currUrl = window.location.href.split('/')
    if (currUrl.includes('community') || currUrl.includes('post')) {
      setCurrTab('community')
    } else if (currUrl.includes('feed')) {
      setCurrTab('feed')
    } else if (currUrl.includes('achievement')) {
      setCurrTab('achievement_rate')
    } else {
      setCurrTab('info')
    }
  }, [match])
  return (
    <NavListWrapper>
      <NavItem>
        {currTab === 'info' ? (
          <ActiveNavItem>정보</ActiveNavItem>
        ) : (
          <NavItemText onClick={() => onReplace('info')}>정보</NavItemText>
        )}
      </NavItem>
      <NavItem>
        {currTab === 'community' ? (
          <ActiveNavItem>커뮤니티</ActiveNavItem>
        ) : (
          <NavItemText onClick={() => onReplace('community')}>커뮤니티</NavItemText>
        )}
      </NavItem>
      <NavItem>
        {currTab === 'feed' ? (
          <ActiveNavItem>피드</ActiveNavItem>
        ) : (
          <NavItemText onClick={() => onReplace('feed')}>피드</NavItemText>
        )}
      </NavItem>
      {/* <NavItem>
                {currTab === 'achievement_rate' ? (
                    <ActiveNavItem>
                        달성률
                    </ActiveNavItem>
                ) : (
                    <NavItemText onClick={() => onReplace('achievement_rate')}>
                        달성률
                    </NavItemText>
                )}
            </NavItem> */}
    </NavListWrapper>
  )
}

const NavListWrapper = styled.ul`
  position: fixed;
  top: calc(100vw * (51 / 375));
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #d5d5d5;
  text-align: center;
  background: #fff;
  z-index: 200;
`

const NavItem = styled.li`
  flex: 1;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: calc(100vw * (-0.38 / 375));
  color: #c6c6c6;
`

const navItemStyle = css`
  display: block;
  width: 100%;
  padding-bottom: calc(100vw * (10.5 / 375));
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: calc(100vw * (-0.38 / 375));
  color: #c6c6c6;
`

const NavItemText = styled.span`
  ${navItemStyle}
`

const ActiveNavItem = styled.span`
  ${navItemStyle}
  border-bottom: calc(100vw * (3 / 375)) solid #1d1d1d;
  color: #121212;
`
